import React, { PureComponent } from 'react';
import { Link } from '../../lib/nextCompat';
import { Hero } from './styles';
import { useT } from '@spotify-internal/i18n-core';
import { useNumberFormatter } from '../../../../../features/src/i18n';

type ArtistBannerClassComponentProps = {
  url?: string;
  search?: string;
  title?: string;
  hero?: {
    bannerImage: string;
    artistId: string;
    artistName: string;
    listeners: number;
  };
  t: $TSFixMeFunction;
  numberFormatter: $TSFixMeFunction;
};

class ArtistBannerClassComponent extends PureComponent<ArtistBannerClassComponentProps> {
  render() {
    const { url, title, hero, search = '', t, numberFormatter } = this.props;
    const noNav = /\.plain$/.test(url || '') || /plain/.test(search);

    return (
      <Hero
        className="hero frodor-nav"
        style={{
          backgroundImage: hero && `url("${hero.bannerImage}")`,
          marginTop: noNav ? 0 : undefined,
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-sm-6">
              <h1 className="display-2 text-white">
                {title && url && (
                  <Link href={url} prefetch={false}>
                    <a>{title}</a>
                  </Link>
                )}
              </h1>
              {hero && (
                <div className="hero-artist-info hidden-xs hidden-sm">
                  <h2>
                    <a
                      className="external"
                      href={`https://open.spotify.com/artist/${hero.artistId}?utm_campaign=s4a|header|${hero.artistId}&utm_source=s4a&utm_medium=s4aheader`}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={t(
                        'FRODOR_893097',
                        'listen to {artistName} on Spotify',
                        '',
                        {
                          artistName: hero.artistName,
                        },
                      )}
                    >
                      {hero.artistName}
                    </a>
                  </h2>
                  <p>
                    {hero.listeners ? (
                      t(
                        'FRODOR_e69386',
                        '{monthlyListeners} Monthly Listeners',
                        '',
                        {
                          monthlyListeners: (
                            numberFormatter as $TSFixMe
                          ).format(hero.listeners),
                        },
                      )
                    ) : (
                      <span>&nbsp;</span>
                    )}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </Hero>
    );
  }
}

const ArtistBanner = (props: $TSFixMe) => {
  const t = useT();
  const numberFormatter = useNumberFormatter();
  return (
    <ArtistBannerClassComponent
      t={t}
      numberFormatter={numberFormatter}
      {...props}
    />
  );
};

export default ArtistBanner;
